import { useLayoutEffect } from 'react'

//Coral background colors for spots containing BackgroundBrick
export const useCoralBrickBackground = (isCoralPage: boolean) => {
  useLayoutEffect(() => {
    const bgColors = ['#FF7673', '#00395D', '#FBAB18', '#11A3A1', '#9CE3FB']
    if (!isCoralPage) return
    document.body.classList.add('is--coral-page')
    Array.from(document.querySelectorAll('.background-brick'))
      .filter((el) => {
        const div = el.querySelector('div')
        return div?.getBoundingClientRect() && div?.getBoundingClientRect().width > 50
      })
      .forEach((el, index) => {
        const div = el.querySelector('div')
        if (div) {
          div.style.backgroundColor = bgColors[index % bgColors.length]
        }
      })
    return () => {
      document.body.classList.remove('is--coral-page')
    }
  }, [isCoralPage])
}
